import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './pages/Auth/ProtectedRoute';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import HomeLayout from './pages/home';
import SuperAdmin from './pages/super/index';
import AdminDashboard from './pages/admin/index';
import CashierDashboard from './pages/user/index';
import CashierLocal from './pages/cashier/index';
import PublicItemViewer from './pages/PublicItemViewer';
import GroceryListPage from './pages/GroceryListPage';
import BarcodeTest from './components/shared/BarcodeTest';
import CashierBarcodeTest from './components/shared/CashierBarcodeTest';
import AppHeader from './components/shared/AppHeader';
import './theme.css';

function App() {
  return (
    <Router>
      <AppHeader />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/superadmin"
          element={
            <ProtectedRoute allowedRoles={['superadmin']}>
              <SuperAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:facilityId/admin"
          element={
            <ProtectedRoute allowedRoles={['admin', 'superadmin']} facilityId={true}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:facilityId/user"
          element={
            <ProtectedRoute allowedRoles={['cashier', 'superadmin']} facilityId={true}>
              <CashierDashboard />
            </ProtectedRoute>
          }
        />
  {/* Local cashier route using cashier session (no Firebase auth) */}
  <Route path="/:facilityId/cashier" element={<CashierLocal />} />
        {/* Public routes - no authentication required */}
        <Route path="/:facilityId/item/:itemId" element={<PublicItemViewer />} />
        <Route path="/view/:facilityId/:itemId" element={<PublicItemViewer />} />
        <Route path="/:facilityId/" element={<GroceryListPage />} />
        <Route path="/test-barcode" element={<BarcodeTest />} />
        <Route path="/test-cashier-barcode" element={<CashierBarcodeTest />} />
  <Route path="/" element={<HomeLayout />} /> {/* Default route -> Landing page */}
      </Routes>
    </Router>
  );
}

export default App;